// src/components/TopicMafia/components/ForceEndDialog.jsx
import React from "react";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { mainActionBtnSx, subActionBtnSx } from "../topicMafiaUi";

export default function ForceEndDialog({
    open,
    onClose,
    reason,
    setReason,
    onConfirm,
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            fullWidth
            maxWidth={isMobile ? false : "xs"}
        >
            <DialogTitle sx={{ fontWeight: 900 }}>정말 강제 종료할까?</DialogTitle>

            <DialogContent dividers>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    진행 중인 게임이 즉시 종료됩니다. (되돌릴 수 없음)
                </Alert>

                <TextField
                    label="종료 사유(선택)"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    fullWidth
                    placeholder="예: 오류 발생 / 인원 이탈 / 테스트 종료"
                    inputProps={{ maxLength: 120 }}
                />
            </DialogContent>

            <DialogActions
                sx={
                    isMobile
                        ? { position: "sticky", bottom: 0, bgcolor: "background.paper", zIndex: 1 }
                        : undefined
                }
            >
                <Button onClick={onClose} sx={subActionBtnSx} fullWidth={isMobile}>
                    취소
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onConfirm}
                    sx={mainActionBtnSx}
                    fullWidth={isMobile}
                >
                    종료
                </Button>
            </DialogActions>
        </Dialog>
    );
}
